import App from './App.html';

const app = new App({
	target: document.body,
	data: {
		chars: 'Kevin Hendel'.split(''),
	},
});

export default app;